import { DynamicService } from 'utils/service';
import {
  WhatsAppContents,
  API_WHATSAPP_CONTENTS,
  WhatsAppContentsTestSendInput,
  WhatsAppContentsCreateUpdateInput,
  GetWhatsAppContentByKeyInput
} from './models';
import { ServiceUserEmployeePermissionWhatsAppContents } from '../user-employee-profile-permission-whatsapp-contents';
import { apiRtk } from 'utils/rtk-query';
import { get } from 'lodash';

export * from './models';

class Service extends DynamicService<WhatsAppContents> {
  getContentByKey = async (input: GetWhatsAppContentByKeyInput) => {
    const {
      data: { value },
    } = await this.getAllDynamic({
      take: 1,
      filter: [`languageID=="${input.languageID}"`, `templateKey=="${input.contentKey}"`].join('&&'),
    });
    const result = value[0];

    if (!result) {
      throw new Error(`WhatsAppContent: "${input.contentKey}" is not exist for the selected language`);
    }

    return result;
  };
  testSend = async (input: WhatsAppContentsTestSendInput) => {
    return this.engine.get(API_WHATSAPP_CONTENTS.SEND, { params: input });
  };

  create = async (input: WhatsAppContentsCreateUpdateInput) => {
    const { userEmployeeProfilePermissionIDs, ...rest } = input;
    const result = await this.post(rest);
    await ServiceUserEmployeePermissionWhatsAppContents.createBulk({
      whatsappContentID: result.data.id,
      userEmployeeProfilePermissionIDs,
    });

    return result;
  };
  update = async (input: WhatsAppContentsCreateUpdateInput) => {
    const { userEmployeeProfilePermissionIDs, ...rest } = input;
    await Promise.all([
      this.patch(rest),
      ServiceUserEmployeePermissionWhatsAppContents.createBulk({
        whatsappContentID: rest.id,
        userEmployeeProfilePermissionIDs,
      }),
    ]);

    return { data: input };
  };

  makeVariables = (template: string | undefined | null, payload: Record<string, any>) => {
    const variables = template || '';

    if (!variables) return [];

    const variablesArray = variables.split(',').map((v) => {
      const key = v.trim();
      const value = get(payload, key) ?? '';

      return { title: key, value };
    });
    
    return variablesArray;
  };
}

export const ServiceWhatsAppContents = new Service({
  mainField: 'id',
  getAll: API_WHATSAPP_CONTENTS.GET_ALL_DYNAMIC,
  post: API_WHATSAPP_CONTENTS.POST,
  patch: API_WHATSAPP_CONTENTS.PATCH,
  delete: API_WHATSAPP_CONTENTS.DELETE,
});

export const apiWhatsAppContents = apiRtk.injectEndpoints({
  endpoints: (builder) => ({
    getWhatsAppContentByKey: builder.query<WhatsAppContents, GetWhatsAppContentByKeyInput>({
      queryFn: async (arg) => {
        try {
          const data = await ServiceWhatsAppContents.getContentByKey(arg);
          return { data };
        } catch (error) {
          return { error: error as Error };
        }
      },
    }),
    getWhatsAppContent: builder.query<WhatsAppContents, string>({
      queryFn: async (arg) => {
        try {
          const { data } = await ServiceWhatsAppContents.getDynamic(arg);
          return { data };
        } catch (error) {
          return { error: error as Error };
        }
      },
    }),
  }),
});
